import { stagingSecrets } from './secrets.staging.local';

export const environment = {
  production: false,
  useAuth0: true,
  vulcan: {
    url: 'https://ck20l9zj65.execute-api.us-east-1.amazonaws.com/prod/',
  },
  botConfig: {
    url: 'https://y7e6298lif.execute-api.us-east-1.amazonaws.com/staging/bot-configuration/',
    latestVersion: 4,
  },
  dumbledore: {
    url: 'https://dumbledore-staging.carlabs.com/',
  },
  bach: {
    url: 'https://bach-staging.carlabs.com/',
  },
  firebase: {
    apiKey: 'AIzaSyDXkg7ZRDFqWU24dPXXyKyOVLETFEAxTPI',
    authDomain: 'brain-ui-v1-staging.firebaseapp.com',
    databaseURL: 'https://brain-ui-v1-staging.firebaseio.com',
    projectId: 'brain-ui-v1-staging',
    storageBucket: 'brain-ui-v1-staging.appspot.com',
    messagingSenderId: '103271147830',
    appId: '1:103271147830:web:86bd760c675fd8fb4f6b97',
    measurementId: 'G-7H8X09HJ0L',
  },
  apiGatewayAnalytics: {
    url: 'https://v01eaqdb08.execute-api.us-east-1.amazonaws.com/',
    url1: 'http://localhost:3000/',
  },
  analyticsWebSocket: {
    url: 'wss://lurl0ifxj3.execute-api.us-east-1.amazonaws.com/staging/',
  },
  platformApi: {
    url: 'https://platformapi-staging.carlabs.com',
  },
  domain: 'dev-d8wrdqvexeqghnvi.us.auth0.com',
  clientId: 'w7DA97ftw6eQxk1cHDpCMgnEVoemoXHV',
  authSecrets: stagingSecrets,
  knowledgeBankAPIKey:
    'gAAAAABntMrlxSLDGRji-3t0rWasxqupVm1vo61Z3iUC9kqD4IWaWxijhMqR4ELgP0pjXQVXA5kwtKd6gufaoeMt1iStNCKinlmt9F2msNy9hqCAo_KzbPbScubwtMejRUSimuXEderRXU831bbNd-r37Blpto_bu6_r9APWQcLnyiMCnUhFOhkqjgDnidZs8iB7RNpgIiatRPxcF53yRetPKRqvxBWTdT2S7dQFQY09Cc_HhnSh6lvB2i7kD5ooF2hZCEF7tyKg',
  voiceAiDashboardFiltersTTL: 15, // 15 minutes
};
